import { render, staticRenderFns } from "./SntAutocompleteAddress.vue?vue&type=template&id=09b97892&"
import script from "./SntAutocompleteAddress.vue?vue&type=script&lang=js&"
export * from "./SntAutocompleteAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports